import React from "react";
import ControlledDatePicker from "../../forms/ControlledDatePicker";
import { styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const DisponibilityInput: React.FC<any> = ({ control }) => {
  const { t } = useTranslation("common");
  return (
    <Root>
      <Typography sx={{ mb: 2 }}>
        {t("profilepage.infos.disponibility")}
      </Typography>
      <Container>
        <ControlledDatePicker
          control={control}
          name="disponibility.dateStart"
          minDate={Date.now()}
          label={t("form.start_date")}
        />
        <ControlledDatePicker
          control={control}
          name="disponibility.dateEnd"
          minDate={Date.now()}
          label={t("form.end_date")}
        />
      </Container>
    </Root>
  );
};

export default DisponibilityInput;
const Root = styled("div")``;
const Container = styled("div")`
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;
